module.exports = __webpack_public_path__ + "static/media/ibm_logo_new.3be7b8b1.svg";